import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link, useSearchParams } from "react-router-dom";
import "../../css/dashboard.css";
import axios from 'axios';
import Pagination from "react-js-pagination";
import styled from "styled-components"

import CommonTable from "../component/table_list/common_table";
import CommonTableRow from "../component/table_list/common_tablerow";
import CommonTableColumn from "../component/table_list/common_tablecolumn";
// import Dropdown from "../component/Dropdown"; // Removed old dropdown
import Menu from "../component/main_menu"
import { formatDate } from "../utils/format_date"
import { formatWon } from "../utils/format_amount"
import { useAuthContext } from '../common/ProtectedLayout';

function TotalReserve(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const [reserveList, setReserveList] = useState([]);
    const [reserveCount, setReserveCount] = useState(0);
    const [page, setPage] = useState(1);
    const items = 10;

    const [view, setView] = useState(false);
    const [selectMenu, setSelectMenu] = useState(() => {
        const filterParam = searchParams.get('filter');
        const validFilters = ['전체', '예약요청', '매칭완료', '작업완료', '예약취소'];
        return validFilters.includes(filterParam) ? filterParam : '전체';
    });
    const [searchText, setSearchText] = useState(''); // 검색 입력 상태
    const [searchQuery, setSearchQuery] = useState(''); // 실제 검색 쿼리 상태
    const auth = useAuthContext();

    const hadlePageChange = (page) => {
        setPage(page);
    };

    const setReservationListWithPaymentSummary = async (reservations) => {
        const list = Array.isArray(reservations) ? reservations : [];
        const reservationIdxs = list.map((reservation) => Number(reservation.idx)).filter(Number.isInteger);
        if (reservationIdxs.length === 0) {
            setReserveList(list);
            return;
        }

        try {
            const summaryResult = await axios.get('/Reservation/AdditionalPaymentSummary', {
                params: { ids: reservationIdxs.join(',') }
            });
            const summaryMap = new Map((summaryResult.data.summaries || []).map((summary) => [
                Number(summary.reservation_idx),
                summary
            ]));
            setReserveList(list.map((reservation) => ({
                ...reservation,
                additional_payment_count: Number(summaryMap.get(Number(reservation.idx))?.additional_payment_count || 0),
                additional_payment_total: Number(summaryMap.get(Number(reservation.idx))?.additional_payment_total || 0)
            })));
        } catch (error) {
            console.error('Error fetching additional payment summary:', error.message);
            setReserveList(list);
        }
    };

    const getReservationTotal = async () => {
        try {
            const getPage = (page - 1) * 10;
            const params = searchQuery.trim() !== '' ? { query: searchQuery } : {};
            switch (selectMenu) {
                case "예약요청":
                    const reserve_result1 = await axios.get(`/Reservation/Request/${getPage}`, { params });
                    await setReservationListWithPaymentSummary(reserve_result1.data.message);
                    break;
                case "매칭완료":
                    const reserve_result2 = await axios.get(`/Reservation/Matching/${getPage}`, { params });
                    await setReservationListWithPaymentSummary(reserve_result2.data.message);
                    break;
                case "작업완료":
                    const reserve_result3 = await axios.get(`/Reservation/Success/${getPage}`, { params });
                    await setReservationListWithPaymentSummary(reserve_result3.data.message);
                    break;
                case "예약취소":
                    const reserve_result4 = await axios.get(`/Reservation/Cancel/${getPage}`, { params });
                    await setReservationListWithPaymentSummary(reserve_result4.data.message);
                    break;
                case "전체":
                    const reserve_result5 = await axios.get(`/Reservation/Total/${getPage}`, { params });
                    await setReservationListWithPaymentSummary(reserve_result5.data.message);
                    break;
            }
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };

    const getReserveCount = async () => {
        try {
            switch (selectMenu) {
                case "예약요청":
                    const reserve_result1 = await axios.get('/Reservation/RequestCount');
                    setReserveCount(reserve_result1.data.message);
                    break;
                case "매칭완료":
                    const reserve_result2 = await axios.get('/Reservation/MatchingCount');
                    setReserveCount(reserve_result2.data.message);
                    break;
                case "작업완료":
                    const reserve_result3 = await axios.get('/Reservation/SuccessCount');
                    setReserveCount(reserve_result3.data.message);
                    break;
                case "예약취소":
                    const reserve_result4 = await axios.get('/Reservation/CancelCount');
                    setReserveCount(reserve_result4.data.message);
                    break;
                case "전체":
                    const reserve_result5 = await axios.get('/Reservation/TotalCount');
                    setReserveCount(reserve_result5.data.message);
                    break;
            }
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }

    const handleSelect = (menu) => {
        setSelectMenu(menu);
        setView(false);
        setPage(1);
    }

    // 검색 핸들러
    const handleSearch = () => {
        setPage(1);
        setSearchQuery(searchText); // 검색 버튼 클릭 시에만 쿼리 업데이트
    };

    // Enter 키 핸들러
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    useEffect(() => {
        getReservationTotal();
    }, [page, selectMenu, searchQuery])

    useEffect(() => {
        setIsValidAccess(true);
        getReserveCount();
    }, [location.state, navigate, selectMenu]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    return (
        <div style={{ padding: '20px' }}>
            <div className="w90p" style={{ marginTop: '40px', margin: '0 auto', position: 'relative' }}>
                <TopBarContainer>
                    {/* 검색 UI (히든 처리) */}
                    {/* <SearchContainer>
                        <SearchInput
                            type="text"
                            placeholder="예약번호, 아이디, 연락처, 주소, 고객명으로 검색..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                        <SearchButton onClick={handleSearch}>검색</SearchButton>
                    </SearchContainer> */}

                    {/* 필터 UI */}
                    <FilterContainer>
                        <FilterButton onClick={() => setView(!view)}>
                            {selectMenu}
                            <span style={{ fontSize: '12px', color: '#999' }}>▼</span>
                        </FilterButton>
                        {view && (
                            <DropdownList>
                                {['전체', '예약요청', '매칭완료', '작업완료', '예약취소'].map((menu) => (
                                    <DropdownItem key={menu} onClick={() => handleSelect(menu)}>
                                        {menu}
                                    </DropdownItem>
                                ))}
                            </DropdownList>
                        )}
                    </FilterContainer>
                </TopBarContainer>
            </div>
            <div style={{ marginTop: '5px' }}>
                <CommonTable
                        headerTitle={['No', '오더번호', '고객명', '아이디', '연락처', '요청일자', '요청시간', '주소', '결제금액', '담당기사', '기사금액', '등록시간', '진행단계']}
                        columnWidths={['3%', '8%', '6%', '10%', '9%', '7%', '5%', '12%', '9%', '6%', '8%', '10%', '6%']}>
                    {
                        reserveList.map((reserve, index) => {
                            let processStep = '';
                            switch (reserve.working_step) {
                                case '0':
                                    processStep = '예약요청';
                                    break;
                                case '1':
                                    processStep = '매칭완료';
                                    break;
                                case '2':
                                    processStep = '작업완료';
                                    break;
                                case '3':
                                    processStep = '예약취소';
                                    break;
                                default:
                                    processStep = 'N/A';
                                    break;
                            }
                            return (
                                <CommonTableRow key={index} idx={reserve.idx} beforePage={'/totalreserve'} kind={'reservation'}>
                                    <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.req_number}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.user_name}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.user_id}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.phone}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.req_date}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.req_time}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.address.length > 20 ? reserve.address.substring(0, 20) + "..." : reserve.address}</CommonTableColumn>
                                    <CommonTableColumn>
                                        <PaymentAmount>{formatWon(reserve.amount)}</PaymentAmount>
                                        {Number(reserve.additional_payment_count) > 0 && (
                                            <AdditionalPaymentBadge>
                                                추가 {Number(reserve.additional_payment_count)}회 · +{formatWon(reserve.additional_payment_total)}
                                            </AdditionalPaymentBadge>
                                        )}
                                    </CommonTableColumn>
                                    <CommonTableColumn>{reserve.mg_name}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.mg_amount ? `${reserve.mg_amount.toLocaleString()}원` : '-'}</CommonTableColumn>
                                    <CommonTableColumn>{formatDate(reserve.date)}</CommonTableColumn>
                                    <CommonTableColumn kind={'step'}>{processStep}</CommonTableColumn>
                                </CommonTableRow>
                            )
                        })
                    }
                </CommonTable>
            </div>
            <PaginationBox>
                <Pagination
                    activePage={page}
                    itemsCountPerPage={items}
                    totalItemsCount={reserveCount}
                    pageRangeDisplayed={10}
                    onChange={hadlePageChange}>
                </Pagination>
            </PaginationBox>
        </div >
    );
}

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

const PaymentAmount = styled.div`
    font-weight: 600;
    color: #222;
    white-space: nowrap;
`;

const AdditionalPaymentBadge = styled.div`
    display: inline-block;
    margin-top: 4px;
    padding: 2px 6px;
    border-radius: 10px;
    background: #eaf3ff;
    color: #006edc;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.4;
    white-space: nowrap;
`;

const TopBarContainer = styled.div`
    display: flex;
    gap: 15px;
    align-items: flex-start;
    margin-bottom: 10px;
`;

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

const SearchInput = styled.input`
    width: 350px;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.2s;
    
    &:focus {
        outline: none;
        border-color: #006edc;
    }
    
    &::placeholder {
        color: #999;
    }
`;

const SearchButton = styled.button`
    padding: 12px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    
    &:hover {
        background-color: #0056b3;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

const FilterContainer = styled.div`
    position: relative;
    width: 160px;
    margin-bottom: 10px;
`;

const FilterButton = styled.button`
    width: 100%;
    padding: 12px 16px;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    color: #333;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.02);
    
    &:hover {
        border-color: #006edc;
        color: #006edc;
        box-shadow: 0 2px 8px rgba(0,110,220,0.1);
    }
`;

const DropdownList = styled.ul`
    position: absolute;
    top: 105%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    padding: 6px;
    margin: 0;
    z-index: 100;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const DropdownItem = styled.li`
    padding: 10px 12px;
    font-size: 14px;
    color: #555;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s;
    
    &:hover {
        background: #f5f9ff;
        color: #006edc;
        font-weight: 600;
    }
`;

export default TotalReserve;
